export enum SourcingRequestType {
	QUOTE = 'quote',
	ORDER = 'order',
}

export type SourcingRequestTypeKey = keyof typeof SourcingRequestType;
export type SourcingRequestTypeValue =
	(typeof SourcingRequestType)[SourcingRequestTypeKey];

export const SourcingRequestTypeLabels: Record<
	SourcingRequestTypeValue,
	string
> = {
	[SourcingRequestType.QUOTE]: 'Quote',
	[SourcingRequestType.ORDER]: 'Order',
};

export function getSourcingRequestTypeLabel(
	type: string | null | undefined,
): string {
	if (type == null) {
		return '-';
	}

	return (
		SourcingRequestTypeLabels[type as SourcingRequestTypeValue] ?? 'Unknown'
	);
}
